import * as React from 'react';
import { 
    AppBar, 
    TitlePortal, 
    UserMenu, 
    useUserMenu, 
    Logout, 
    MenuItemLink, 
    useGetIdentity
} from 'react-admin';
import { Box, useMediaQuery, Theme } from '@mui/material';
import { useClientContext } from 'contexts/client';
import { DataThruIcon } from 'layout_v4/DataThruIcon'
import SettingsIcon from '@mui/icons-material/Settings';
import { Avatar } from '@mui/material';
import { AppBarToolbar } from './AppBarToolbar';

const SettingsMenuItem = React.forwardRef((props: any, ref: any) => {
    const { onClose } = useUserMenu();
    return (
        <MenuItemLink
            onClick={onClose}
            ref={ref}
            to="/user_profile"
            primaryText={'Profile'}
            leftIcon={<SettingsIcon />}
        />

    );
});

const CustomAppBar = () => {
    const isLargeEnough = useMediaQuery<Theme>(theme =>
        theme.breakpoints.up('sm')
    );
    const { state: client } = useClientContext()
    const ClientAppBarLogo = client.client.appBarLogo
    const { data, isPending } = useGetIdentity();
    if (isPending) return null;
    const { avatar } = data;
    let icon = null
    if (avatar) {
        icon = (<Avatar alt="User Avatar" src={avatar} />)
    }
    return (
        <AppBar 
            color="secondary" 
            toolbar={<AppBarToolbar />}
            userMenu={
            <UserMenu icon={icon}>
                <SettingsMenuItem />
                <Logout />
            </UserMenu>
            }
        >
            <ClientAppBarLogo style={{ width: 130, margin: '.25em 1em' }} />
            <div style={{ paddingLeft: '2em' }}>
            <TitlePortal />
            </div>
            {isLargeEnough && <Box component="span" sx={{ flex: 1 }} />}
            {/* <ToggleThemeButton sx={{ ml: 2 }} /> */}
            <DataThruIcon sx={{ ml: 2 }} />
        </AppBar>
    );
};

export default CustomAppBar;